import store from '../store/store';

export default ({ next, router }) => {
  if (!store.getters['auth/token']) {
    return router.push({ name: 'login' });
  } else {
    next();
  }
};
